<template>
  <div>
    <table
      class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded"
    >
      <thead class="table-active">
        <tr>
          <th class="text-left align-middle">Fecha programada</th>
          <th class="text-center align-middle">Programa</th>
          <th class="text-center align-middle">Responsable</th>
          <th class="text-center align-middle">Observaciones</th>
          <th class="text-center align-middle">Evidencia</th>
          <th class="text-center align-middle">Acciones</th>
          <!--        <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Fecha programada
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Programa
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Responsable
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Observaciones
          </th>
          <th
            scope="col"
            class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
          >
            Evidencia
          </th>
          <th class="text-center align-middle">Acciones</th> -->
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="item in themes" :key="item.id">
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ dateConvert(item.scheduled_date) }}
          </td>
          <td class="text-center align-middle">
            {{ item.programs.name }}
          </td>
          <td class="text-center align-middle">
            {{ item.employees.full_name }}
          </td>
          <td class="text-center align-middle">
            {{ item.observations ? item.observations : "-" }}
            <!-- <p :class="`${item.observations ? 'text-justify' : 'text-center'}`">
              {{ item.observations ? item.observations : "-" }}
            </p> -->
          </td>
          <td class="text-center align-middle">
            <div v-if="item.program_evidencen.length === 0">
              <h6>No se ha subido una evidencia</h6>
            </div>
            <div v-else>
              <button
                :disabled="!allowAccess()"
                style="background-color: transparent !important; border: none"
                type="button"
                @click="
                  gotoDigitalOcean(`${item.program_evidencen[0].evidence}`)
                "
              >
                <i class="mdi mdi-cloud-download"></i>
              </button>
            </div>
          </td>
          <td class="text-center align-middle">
            <div class="col-sm-12">
              <b-dropdown variant="primary">
                <template v-slot:button-content>
                  <i class="mdi mdi-eye"></i>
                </template>
                <b-dropdown-item
                  :disabled="!getRole('Editar') || !allowAccess()"
                  :to="{
                    path: `/forms/estandares/actividades-promocion-evidencia/${item.id}`,
                  }"
                >
                  Subir evidencia</b-dropdown-item
                >
               <!--  <b-dropdown-item
                  :disabled="!getRole('Editar') || !allowAccess()"
                  :to="{
                    path: `/forms/estandares/medicion-frecuencia-ver/${item.id}`,
                  }"
                >
                  Ver</b-dropdown-item
                > -->

                <b-dropdown-item
                  :disabled="!getRole('Editar') || !allowAccess()"
                  :to="{
                    path: `/forms/estandares/actividades-promocion/${item.id}`,
                  }"
                >
                  Editar</b-dropdown-item
                >
                <b-dropdown-item
                  :disabled="!getRole('Eliminar') || !allowAccess()"
                  >Eliminar</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination
      :companyID="companyID"
      ref="paginator"
      :search="search"
      @fetch="(items) => (themes = items)"
    />
  </div>
</template>

<script>
import Pagination from "./PromotionPagination";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      themes: [],
      search: null,
      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(24)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },


    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    go(ID) {
      this.$router.push({
        path: `/forms/estandares/${this.companyID}/promocion-prevencion/${ID}`,
      });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    print(url) {
      if (!url) return;
      window.location.href = url;
    },

    getThemeID(theme) {
      if (theme === "BIOLÓGICO") {
        return 1;
      } else if (theme === "FÍSICO") {
        return 2;
      } else if (theme === "QUÍMICO") {
        return 3;
      } else if (theme === "PSICOSOCIAL") {
        return 4;
      } else if (theme === "BIOMECÁNICO") {
        return 5;
      } else if (theme === "CONDICIONES") {
        return 6;
      } else if (theme === "FENÓMENOS") {
        return 7;
      } else {
        return 8;
      }
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>
